const defaultValuesFilters = {
    radius: null,
    deliveryLevel: null,
    distance: null,
    from: 0,
    till: 100000,
    livingArea: 0,
    rentalType: null,
    rooms: 0,
    neighborhoodSlug: null,
    districtSlug: null,
    streetSlug: null,
    outside: [],
    location: undefined,
    page: 1,
    sorting: 'datum-af',
}

export default defaultValuesFilters;